import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import type { CardSpacingSize, ItemType } from '@/modules/expense-reports/types';
import type { JSX } from 'react';
interface Props {
  header: JSX.Element | string;
  headers: Array<JSX.Element | string>;
  items?: JSX.Element[];
  separators?: boolean[];
  footer?: JSX.Element | string;
  // TODO: Type this to avoid lower and uppercase error
  itemType: ItemType;
  cardSpacingSize?: CardSpacingSize;
  subHeader: string;
  showSubHeader: boolean;
  category?: string;
}
function TransparencyCard(t0) {
  const $ = _c(25);
  const {
    cardSpacingSize: t1,
    header,
    headers,
    itemType,
    subHeader,
    footer,
    items,
    separators,
    showSubHeader,
    category: t2
  } = t0;
  const cardSpacingSize = t1 === undefined ? "large" : t1;
  const category = t2 === undefined ? "General" : t2;
  if (itemType === "section") {
    return null;
  }
  const t3 = `advance-table--transparency-card ${itemType === "total" ? "advance-table--transparency-card_total" : "advance-table--transparency_item"}`;
  let t4;
  if ($[0] !== t3) {
    t4 = cn("bg-card flex flex-col overflow-hidden rounded-xl pb-2 shadow-lg", t3);
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== category || $[3] !== showSubHeader || $[4] !== subHeader) {
    t5 = showSubHeader && <div className={cn("bg-accent flex flex-col gap-2 px-6 py-2")}><div className="text-base/6 font-semibold">{category}</div><div className="text-sm/5.5 font-semibold">{subHeader}</div></div>;
    $[2] = category;
    $[3] = showSubHeader;
    $[4] = subHeader;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== cardSpacingSize || $[7] !== headers || $[8] !== itemType || $[9] !== items || $[10] !== separators) {
    let t7;
    if ($[12] !== cardSpacingSize || $[13] !== itemType || $[14] !== items || $[15] !== separators) {
      t7 = (header_0, i) => {
        const titleReactComponent = (header_0 as JSX.Element).props?.title || "";
        const isTotal = header_0 === "Totals" || titleReactComponent === "Totals";
        return <div key={`${header_0.toString()}-${i}`} className={cn("[&_.advanced-table__cell-row--category--comments]:p-0 [&_.advanced-table__cell-row--category--comments]:text-end", "[&_.advanced-table__cell-row--category--comments]:[&_div]:h-0 [&_.advanced-table__cell-row--category--comments]:[&_div]:w-0", cardSpacingSize === "large" ? "px-6 pt-5 pb-2.5" : "px-6")}><div className={cn("md:flex-start flex flex-1 items-center md:justify-between", {
            "justify-between": header_0 !== "Target Balance" || itemType === "total"
          })}><div className={cn("flex min-w-[132px] items-center text-base/6 font-semibold", isTotal ? "text-foreground" : "text-foreground/50")}>{header_0}</div><div className={cn("justify-end", {
              flex: itemType === "total"
            }, {
              "w-full": header_0 === "Target Balance" || header_0 === "Target Balance" && itemType !== "total"
            })}>{items?.[i] ?? ""}</div></div>{separators?.[i] && <div className={cn("my-2 flex flex-1 border-t")} />}</div>;
      };
      $[12] = cardSpacingSize;
      $[13] = itemType;
      $[14] = items;
      $[15] = separators;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    t6 = headers.map(t7);
    $[6] = cardSpacingSize;
    $[7] = headers;
    $[8] = itemType;
    $[9] = items;
    $[10] = separators;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[17] !== footer) {
    t7 = footer && <div className={cn("mt-4 flex justify-center border-t px-0 pt-0")}>{footer}</div>;
    $[17] = footer;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== header || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7) {
    t8 = <div className={t4}>{t5}{header}{t6}{t7}</div>;
    $[19] = header;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}
export { TransparencyCard };